export default __webpack_public_path__ + "static/media/contact.fc425129.jpg";